// extracted by mini-css-extract-plugin
export default {"radio":"SuperRadio_radio__+QPrE","label":"SuperRadio_label__iEO2S","options":"SuperRadio_options__vUoMj"};